import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  EMPTY_OBJECT,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../constants/common'
import Button, { BUTTON_HEIGHT_24 } from '../Button'
import { FileUploadConstantInputWrap, useFileDropzone } from '../File'
import { ButtonIconSelectControl, ButtonSelect } from '../Select'

import {
  ATTACH_ACTION_SELECT_DROPDOWN_WIDTH,
  QA_NAME_ATTACH_ACTION_SELECT_DROPDOWN,
} from './AttachActionSelect.constants'
import { isAttachActionSelectActionFile } from './AttachActionSelect.utils'

import * as styles from './AttachActionSelect.module.css'

import AttachIcon from '../../icons/attach.svg'

/**
 * WARNING!
 *
 * This select should be used if must to have `Attach file` option and something else.
 * Cause select contains hidden file input which make file uploading works in `Firefox`.
 * `Firefox` can't upload file without file input.
 *
 * If `Attach file` option isn't need then use simple select.
 */
function AttachActionSelect({
  beforeIconProps: { Icon = AttachIcon, ...beforeIconProps } = EMPTY_OBJECT,
  buttonHeight = BUTTON_HEIGHT_24,
  disabled,
  options,
  outboundUuid,
  placeholder = 'Select.AttachActionKey',
  onClick,
  onFinishUpload,
  onStartUpload,
  onUploadErrors,
  ...restProps
}) {
  const { t } = useTranslation()

  const [modal, setModal] = useState(null)

  function handleCloseModal() {
    return setModal(null)
  }

  const { getInputProps: getFileAttachInputProps, open: handleOpenFileAttach } =
    useFileDropzone({
      outboundUuid,
      onCloseModal: handleCloseModal,
      onFinishUpload,
      onSetModal: setModal,
      onStartUpload,
      onUploadErrors,
    })

  function handleClick(option) {
    if (isAttachActionSelectActionFile(option.value)) {
      handleOpenFileAttach()
    }

    onClick?.(option)
  }

  return (
    <FileUploadConstantInputWrap
      getFileAttachInputProps={getFileAttachInputProps}
    >
      <ButtonSelect
        {...restProps}
        Control={ButtonIconSelectControl}
        className={styles.AttachActionSelect}
        controlProps={{
          Button: Button.Text,
          buttonProps: {
            beforeIconProps: { ...beforeIconProps, Icon },
            buttonHeight,
            disabled,
            qaName: QA_NAME_ATTACH_ACTION_SELECT_DROPDOWN,
            text: t(placeholder),
          },
        }}
        disabled={disabled}
        dropdownFloatingConfig={{
          dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottomStart,
          dropdownStyles: {
            maxWidth: ATTACH_ACTION_SELECT_DROPDOWN_WIDTH,
          },
          maxWidthByRef: false,
        }}
        listProps={{
          itemProps: {
            contentProps: {
              infoProps: {
                contentTextProps: {
                  textProps: {
                    isSecondary: true,
                  },
                },
              },
            },
          },
        }}
        options={options}
        onSelectItem={handleClick}
      />
      {modal}
    </FileUploadConstantInputWrap>
  )
}

export default AttachActionSelect
